import { Controller } from "@hotwired/stimulus";
import DOMPurify from "dompurify";
import $ from "jquery";
export default class extends Controller {
  static targets = [
    "eeInput",
    "addInter",
    "prompt",
    "ppReview",
    "modal",
    "addInterModal",
    "submitButton",
    "interField",
  ];

  showPp() {
    event.preventDefault();
    this.promptTarget.classList.add("d-none");
    this.modalTarget.style.maxWidth = "90vw";
    this.ppReviewTarget.classList.remove("d-none");
  }

  showInterAdd() {
    event.preventDefault();
    this.ppReviewTarget.classList.add("d-none");
    this.addInterModalTarget.classList.remove("d-none");
    this.modalTarget.style.maxWidth = "60vw";
  }

  handleSubmit() {
    setTimeout(() => {
      $("#addIntervenantModal").modal("hide");
    }, 500);
  }

  disableClick() {
    console.log("disable");
    this.submitButtonTarget.disabled = true;
    this.element.querySelector("form").submit();
  }

  loadIntervenants(event) {
    this.interFieldTargets.forEach((interField) => {
      this.application
        .getControllerForElementAndIdentifier(interField, "wp-intervenants")
        .loadIntervenants(event);
    });
  }
}
